import { SetIsLoadingAction } from '../loadingActionTypes';
import { ActionTypes } from '../types';

export function setIsLoading(isLoading : boolean): SetIsLoadingAction {
    return {
      type: ActionTypes.SET_IS_LOADING,
      payload: isLoading
    }
}